var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 580,
    height: 610,
    viewBox: "0 0 580 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.678 490.571C124.678 490.571 133.755 494.351 150.938 499.008C150.974 499.02 150.409 526.56 150.862 529.067C152.053 528.341 152.814 526.213 152.814 526.213C152.814 526.213 157.72 501.321 157.822 500.948C172.38 504.092 186.346 506.634 202.846 509.42C203.112 508.857 174.508 498.612 159.762 493.943C160.105 492.715 168.732 469.454 169.576 466.52C169.607 464.884 168.85 464.35 168.85 464.35C168.85 464.35 153.223 491.263 152.867 492.467C135.04 488.411 126.123 486.981 126.123 486.981C114.665 485.691 124.672 490.59 124.672 490.59",
    fill: "#314064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.961 512.688C397.764 521.782 586.547 420.771 642.71 217.485L624.618 217.79C601.282 354.759 428.024 538.511 209.588 507.823C215.05 511.103 248.8 512.349 254.961 512.688Z",
    fill: "#314064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarLine);
export default __webpack_public_path__ + "static/media/star-line.9ea815409cb1efa26bf239e7b5adbee5.svg";
export { ForwardRef as ReactComponent };